import { render, staticRenderFns } from "./CampaignSendStep.vue?vue&type=template&id=1892ffec&scoped=true&"
import script from "./CampaignSendStep.vue?vue&type=script&lang=js&"
export * from "./CampaignSendStep.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSendStep.vue?vue&type=style&index=0&id=1892ffec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1892ffec",
  null
  
)

export default component.exports